<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#9ixhq605na)">
            <path
                d="M11.46 11H.53c-.41 0-.67-.44-.46-.79l5.48-8.96c.21-.34.71-.34.91 0l5.46 8.94c.22.35-.04.8-.46.8V11zm-5.2-1.06c.21-.21.32-.43.32-.69 0-.22-.08-.4-.23-.55a.761.761 0 0 0-.56-.22c-.29 0-.54.11-.74.32-.2.21-.31.45-.31.71 0 .22.07.4.22.54s.34.21.56.21c.28 0 .52-.1.73-.31l.01-.01zm-.78-4.79c-.07.56-.14 1.06-.21 1.49-.07.43-.11.67-.11.71 0 .17.07.29.21.38.14.09.32.14.53.14.25 0 .5-.06.75-.19-.01-.06-.02-.16-.02-.31 0-.54.1-1.23.31-2.06.2-.84.31-1.33.31-1.48 0-.39-.28-.59-.85-.59-.25 0-.54.04-.85.11.01.08.02.22.02.43 0 .35-.03.81-.1 1.37h.01z"
            />
        </g>
        <defs>
            <clipPath id="9ixhq605na">
                <path d="M0 0h12v12H0z" />
            </clipPath>
        </defs>
    </svg>
</template>
